import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import type { RadioGroupProps } from 'components/common/radio-group';
import RadioGroup from 'components/common/radio-group';

const ControlledRadioGroup = withLabel(withController<RadioGroupProps>(RadioGroup, { withoutRef: true }));
export default ControlledRadioGroup;
